"use strict";

var _classCallCheck = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MockEIP1193Provider = void 0;

var eventemitter3_1 = require("eventemitter3");

var MockEIP1193Provider = /*#__PURE__*/function (_eventemitter3_1$Even) {
  _inherits(MockEIP1193Provider, _eventemitter3_1$Even);

  var _super = _createSuper(MockEIP1193Provider);

  function MockEIP1193Provider() {
    var _this;

    _classCallCheck(this, MockEIP1193Provider);

    _this = _super.apply(this, arguments);
    _this.eth_chainId = jest.fn(function (chainId) {
      return chainId;
    });
    _this.eth_accounts = jest.fn(function (accounts) {
      return accounts;
    });
    _this.eth_requestAccounts = jest.fn(function (accounts) {
      return accounts;
    });
    return _this;
  }

  _createClass(MockEIP1193Provider, [{
    key: "request",
    value: function request(x) {
      // make sure to throw if we're "not connected"
      if (!this.chainId) return Promise.reject(new Error());

      switch (x.method) {
        case 'eth_chainId':
          return Promise.resolve(this.eth_chainId(this.chainId));

        case 'eth_accounts':
          return Promise.resolve(this.eth_accounts(this.accounts));

        case 'eth_requestAccounts':
          return Promise.resolve(this.eth_requestAccounts(this.accounts));

        default:
          throw new Error("Method not supported on mock: ".concat(JSON.stringify(x)));
      }
    }
  }, {
    key: "emitConnect",
    value: function emitConnect(chainId) {
      this.emit('connect', {
        chainId: chainId
      });
    }
  }, {
    key: "emitDisconnect",
    value: function emitDisconnect(error) {
      this.emit('disconnect', error);
    }
  }, {
    key: "emitChainChanged",
    value: function emitChainChanged(chainId) {
      this.emit('chainChanged', chainId);
    }
  }, {
    key: "emitAccountsChanged",
    value: function emitAccountsChanged(accounts) {
      this.emit('accountsChanged', accounts);
    }
  }]);

  return MockEIP1193Provider;
}(eventemitter3_1.EventEmitter);

exports.MockEIP1193Provider = MockEIP1193Provider;